import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  max-width: 1065px;
  width: 100%;
`

export const Title = styled.span`
  ${Typography.M};
  color: ${Colors.Neutral90};
  ${FontWeights.DemiBold};
  text-align: center;

  ${Media.Phone`
    ${Typography.Subhead};
  `};
`

export const LogosContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  ${Media.Phone`
    flex-wrap: wrap;
    justify-content: center;
  `};
`

export const Logo = styled.img`
  width: 100%;
`

export const LogoMobile = styled.img`
  display: none;
  width: 25%;

  ${Media.Phone`
    display: flex;
  `};
`

export const LogoImageContainer = styled.div`
  flex-grow: 1;

  ${Media.Phone`
    display: none;
  `};
`
